// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/organization/BusinessContextSection.jsx

import React from "react";
import { Field, TextArea } from "../../../design-system/components";
import OrganizationSectionCard from "./OrganizationSectionCard";

export default function BusinessContextSection({ draft, setField }) {
  return (
    <OrganizationSectionCard
      eyebrow="Business context"
      title="Mission and business objectives"
      description="Keep compliance operations tied to the outcomes the enterprise is working to protect."
    >
      <div className="enterprise-admin-organization-fields">
        <Field
          label="Mission statement"
          className="enterprise-admin-organization-field-wide"
        >
          <TextArea
            value={draft.mission_statement || ""}
            onChange={(event) => setField("mission_statement", event.target.value)}
            placeholder="Describe the organization’s operating mission."
            rows={4}
          />
        </Field>

        <Field
          label="Business objectives"
          help="Enter one objective per line."
          className="enterprise-admin-organization-field-wide"
        >
          <TextArea
            value={draft.business_objectives_text || ""}
            onChange={(event) => setField("business_objectives_text", event.target.value)}
            placeholder={"One objective per line\nEstablish trusted compliance operations"}
            rows={5}
          />
        </Field>
      </div>
    </OrganizationSectionCard>
  );
}
